


















import { Component, Mixins, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import GJgrowEventDetailProgressView from '@/views/GJgrowEventDetail/GJgrowEventDetailProgressView.vue';
import GTitleBar from '@/components/GTitleBar.vue';
import { GPageBase } from '@/mixins';
import { jgrowEventCreateModule } from '@/store/modules/frames/jgrow-event-create.module';
import { jgrowEventProgressModule } from '@/store/modules/frames/jgrow-event-progress.module';
import { EventProgress } from '@/models/jgrow/event-progress';

@Component({
  name: 'GJgrowEventDetailProgress',
  components: {
    GJgrowEventDetailProgressView,
    GTitleBar,
  },
  computed: {},
  methods: {},
})
export default class GJgrowEventDetailProgress extends mixins(GPageBase) {

  created() {}
  async mounted() {}

  get progressBySchoolGrade(): Map<string, EventProgress[]> {
    return jgrowEventProgressModule.progressBySchoolGrade;
  }

  handleProgressDownload() {
    jgrowEventProgressModule.downloadProgress(jgrowEventCreateModule.createdEvent).then(() => {
      console.log("done");
    });
  }
}
